import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "Common/Components/examples/Sidenav";
import theme from "Common/hooks/assets/theme";
import { useSoftUIController } from "Common/hooks/context";
import brand from "Common/hooks/assets/images/lmsLogo1.png";
import Login from "Common/Auth/SignIn";
import DashboardLayout from "Common/Components/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "Common/Components/examples/Navbars/DashboardNavbar";
import { showSidebar } from "Common/Client/routeUtils";
import Register from "Common/Auth/SignUp";
import routes from "../SelfLearnerRoutes";
import SelfLandingPage from "../../Dashboards/SelfLearnerDashboard/SelfLandingPage";
import AvailableCourses from "../../Components/Courses/AvailableCourses";
import CourseDetail from "../../Components/Courses/CourseDetails";
import EnrolledCourses from "PlatForms/SelfLMS/Components/Courses/EnrolledCourses";
import EnrolledCourseDetails from "PlatForms/SelfLMS/Components/Courses/EnrolledCourseDetails";
import PageDetails from "PlatForms/SelfLMS/Components/Courses/PageDetails";
import AssessmentPage from "PlatForms/SelfLMS/Components/Courses/Assessment";
import CredentialsPage from "PlatForms/SelfLMS/Components/Credentials/Credentails";
import CertificateDetailPage from "PlatForms/SelfLMS/Components/Credentials/CertificateDetails";
import SelfLearnerProfile from "PlatForms/SelfLMS/Components/Profile/SelfLearnerProfile";
import PersonalInterest from "PlatForms/SelfLMS/Components/PersonalInterest/PersonalInterest";
import PaymentSuccess from "PlatForms/SelfLMS/Components/Payment/PaymentSuccess";
import PaymentCancel from "PlatForms/SelfLMS/Components/Payment/PaymentCancle";
import PaymentLedgerPage from "PlatForms/SelfLMS/Components/PaymentLedger/PaymentLedger";
import PaymentLedgerDetailPage from "PlatForms/SelfLMS/Components/PaymentLedger/PaymentLedgerDetail";
import ExpertServicesLearnerPage from "PlatForms/SelfLMS/Components/ExpertService/ExpertService";
import ExpertServiceDetailPage from "PlatForms/SelfLMS/Components/ExpertService/ExpertServiceDetail";
import PaymentSuccessService from "PlatForms/SelfLMS/Components/ExpertService/Payment/PaymentSuccess";
import PaymentCancelService from "PlatForms/SelfLMS/Components/ExpertService/Payment/PaymentCancle";
import PurchasedExpertServicesPage from "PlatForms/SelfLMS/Components/ExpertService/PurchasedExpertServices";

function SelfLearnerContent() {
  const [controller] = useSoftUIController();
  const { layout, sidenavColor } = controller;
  const location = useLocation();

  useEffect(() => {
    sessionStorage.setItem("currentPath", location.pathname);
    console.log(" Current SelfLearner Route:", location.pathname);
  }, [location.pathname]);

  const isCertificatePage = location.pathname.includes("/certificate/");

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      {/* Sidebar - hide on certificate page */}
      {layout === "dashboard" && showSidebar && !isCertificatePage && (
        <Sidenav
          color={sidenavColor}
          brand={brand}
          brandName="Learner"
          routes={routes}
        />
      )}

      {/* Dashboard layout */}
      <DashboardLayout>
        {/* Navbar - hide on certificate page if you want full page */}
        {!isCertificatePage && <DashboardNavbar />}

        <Routes>
          {/* Dashboard Route */}
          <Route path="/" element={<SelfLandingPage />} />

          {/* Available Courses Route */}
          <Route path="/available-courses" element={<AvailableCourses />} />
          <Route path="/enrolled-courses" element={<EnrolledCourses />} />

          {/*Payment Ledger*/}
          <Route path="/payment-ledger" element={<PaymentLedgerPage/>} />
          <Route path= "/payment-ledger-detail/:ledgerId" element = {<PaymentLedgerDetailPage/>} />

          {/* Certificate routes */}
          <Route path="/credentials" element={<CredentialsPage />} />
         
          <Route path="certificate/:certificateId" element={<CertificateDetailPage />} />

          {/* Course Detail Routes */}
          <Route path="/available-courses/courses/:courseId" element={<CourseDetail />} />
          <Route path="/enrolled-courses/courses/:enrollmentId" element={<EnrolledCourseDetails />} />
          <Route path="/enrolled-courses/:enrollmentId/modules/:moduleProgressId/pages/:pageId" element={<PageDetails />} />
          <Route path="/enrolled-courses/:enrollmentId/modules/:moduleProgressId/assessment" element={<AssessmentPage />} />
          <Route path="/selfLearner-profile" element={< SelfLearnerProfile />} />
          <Route path="/personal-interest" element={<PersonalInterest />} />

          <Route
            path="/courseenroll/payment-success"
            element={<PaymentSuccess />}
          />

         
          <Route
            path="/courseenroll/payment-cancel"
            element={<PaymentCancel />}
          />

          {/*Expert Routes*/}
            <Route path="/expert-services" element={<ExpertServicesLearnerPage />} />
            <Route path="/purchased-expert-services" element={<PurchasedExpertServicesPage />} />

           <Route path="/learner/expert-services/:serviceId" element={<ExpertServiceDetailPage />} />
          <Route
            path="/expertservice/payment-success"
            element={<PaymentSuccessService />}
          />

         
          <Route
            path="/expertservice/payment-cancel"
            element={<PaymentCancelService />}
          />

          {/* Auth Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </DashboardLayout>
    </ThemeProvider>
  );
}

export default SelfLearnerContent;
